/*
* System
* Cluster 설정
* 가상 IP 관리
*
*
* @since 2023-02-14
* @author wj_tams_dev01
* */

import {SystemApiPrefix} from '~/utils/restApi'

const urlPrefix = `${SystemApiPrefix}/cluster/resources`

export const state = () => ({
  virtualIpList: [] // 가상 IP 리스트
})

export const mutations = {
  init (state) {
    state.virtualIpList = []
  },

  initVirtualIpList (state, virtualIpList) {
    if (_.isArray(virtualIpList)) {
      state.virtualIpList = virtualIpList
    } else {
      state.virtualIpList = []
    }
  }
}

export const actions = {

  /* 가상 IP 목록 조회 */
  async getVirtualIpList ({commit}, {param, loading = true} = {}) {
    let res = {code: 'ok'}
    let urlVirtualIpManagement = `${urlPrefix}`
    if (_.isPlainObject(param) && _.isNumber(param.searchType) && _.isString(param.searchText) && param.searchText !== '') {
      if (param.searchType === 0) { // IP 검색
        urlVirtualIpManagement += '?search_item=1&search_word=' + encodeURIComponent(param.searchText)
      } else { // 인터페이스 검색
        urlVirtualIpManagement += '?search_item=2&search_word=' + encodeURIComponent(param.searchText)
      }
    }
    try {
      const {code, result} = await this.$axios.$get(urlVirtualIpManagement, {loading})
      if (code === 'ok') {
        commit('initVirtualIpList', result)
      } else {
        res = {code: 'nok', reason: result.msg}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },

  /* ZTP 토큰 생성 */
  async addVirtualIp ({commit, state}, {param, loading = true, successAlert = true} = {}) {
    let res = {code: 'ok'}
    const urlVirtualIpManagement = `${urlPrefix}/vip`
    try {
      const {code, result} = await this.$axios.$post(urlVirtualIpManagement, param, {loading, successAlert})
      if (code === 'ok') {
        res.result = result
      } else {
        res = {code: 'nok', reason: result.msg}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },

  /* ZTP 토큰 편집 */
  async editVirtualIp ({state}, {param}) {
    let res = {code: 'ok'}
    if (!_.isPlainObject(param) || !_.isNumber(param.resource_id)) {
      res = {code: 'nok', reason: 'resource_id is null'}
      return res
    }
    const urlVirtualIpManagement = `${urlPrefix}/vip/${param.resource_id}`
    try {
      const {code, result} = await this.$axios.$put(`${urlVirtualIpManagement}`, param, {successAlert: false, loading: false})
      if (code !== 'ok') {
        if (result.msg === undefined) {
          res = {code: 'nok', reason: '', result: result}
        } else {
          res = {code: 'nok', reason: result.msg, result: result}
        }
      } else {
        res = {code: 'ok', result: result}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },

  /* ZTP 토큰 삭제 */
  async delVirtualIp ({state}, {param}) {
    let res = {code: 'ok'}
    if (!_.isPlainObject(param) || !_.isNumber(param.resource_id)) {
      res = {code: 'nok', reason: 'resource_id is null'}
      return res
    }
    const urlVirtualIpManagement = `${urlPrefix}/vip/${param.resource_id}`
    try {
      const {code, result} = await this.$axios.$delete(`${urlVirtualIpManagement}`, {successAlert: false, loading: false})
      if (code !== 'ok') {
        if (result.msg === undefined) {
          res = {code: 'nok', reason: '', result: result}
        } else {
          res = {code: 'nok', reason: result.msg, result: result}
        }
      } else {
        res = {code: 'ok', result: result}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },

  /* 가상 IP 관리 적용/취소 */
  async finalCommand ({state}, type) {
    let res = {code: 'ok'}
    const apiUri = `${urlPrefix}/${type}`,
      axiosConfig = (type === 'apply') ? {applyMsg: true} : {cancelMsg: true}
    try {
      const result = await this.$axios.$put(apiUri, void 0, axiosConfig)
      res = result
    } catch (e) {
      res = {code: 'nok', result: {msg: e}}
    }
    return res
  }
}
